var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsmWorksEllipse = function SvgAsmWorksEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 888,
    height: 621,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 5,
    d: "M334.409 76.98c235.9-110.472 476.087-95.508 536.465 33.424S788.96 433.411 553.056 543.883 76.969 639.391 16.591 510.459 98.505 187.452 334.41 76.979Z"
  })));
};
export default SvgAsmWorksEllipse;